import React, { Fragment } from 'react'
import { Slider } from 'components/Widgets/Home'
import useConfig from 'store/ConfigProvider'
import { SliderAndFresh } from 'style/Home.style'
import { DesktopHeaderCategories } from '../../../components/Widgets/Categories/Categories'

const SliderAndCategory = () => {
  const { categories, topCategories } = useConfig()
  return (
    //<HomeSliderContainer id="homeslider">
    <Fragment>
      <DesktopHeaderCategories
        categories={categories}
        topCategories={topCategories}
      />
      <SliderAndFresh>
        <Slider />
        {/*    <BrowserView>
          <FreshPromotions type={'desktop'} />
        </BrowserView> */}
      </SliderAndFresh>
      {/*  <MobileView>
        <FreshPromotions type={'mobile'} />
      </MobileView>
      <TabletView>
        <FreshPromotions type={'tablet'} />
      </TabletView> */}
    </Fragment>
    //</HomeSliderContainer>
  )
}

export default SliderAndCategory
